var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5651 2.68674V2.00755C10.5651 1.04632 9.78583 0.26709 8.8246 0.26709H1.86277C0.901544 0.26709 0.122314 1.04632 0.122314 2.00755V10.1297C0.122314 11.0909 0.901544 11.8701 1.86277 11.8701H9.98491C10.9461 11.8701 11.7254 11.0909 11.7254 10.1297V4.32816C11.7254 3.57035 11.2411 2.92566 10.5651 2.68674ZM1.28262 2.00755C1.28262 1.68714 1.54236 1.4274 1.86277 1.4274H8.8246C9.14501 1.4274 9.40476 1.68714 9.40476 2.00755V2.5877H1.86277C1.54236 2.5877 1.28262 2.32796 1.28262 2.00755ZM1.28262 3.64897C1.46408 3.71311 1.65935 3.74801 1.86277 3.74801H9.98491C10.3053 3.74801 10.5651 4.00775 10.5651 4.32816V5.48846H8.8246C7.86338 5.48846 7.08415 6.26769 7.08415 7.22892C7.08415 8.19015 7.86338 8.96938 8.8246 8.96938H10.5651V10.1297C10.5651 10.4501 10.3053 10.7098 9.98491 10.7098H1.86277C1.54236 10.7098 1.28262 10.4501 1.28262 10.1297V3.64897ZM8.8246 6.64877H10.5651V7.80907H8.8246C8.5042 7.80907 8.24445 7.54933 8.24445 7.22892C8.24445 6.90851 8.5042 6.64877 8.8246 6.64877Z",
    fill: "#535763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.5129172473ae37c62bdbbe9e858c32f6.svg";
export { ForwardRef as ReactComponent };